import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LegalBasis3BasicRolandDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  const zipCodeError = schemaUtils.zipCodeErrorMap(issue)
  return zipCodeError ?? { message: ctx.defaultError }
}

const legal_zip = (params: StepConfigParams) =>
  ({
    schema: z.object({
      zip_code: BaseSchema_LegalBasis3BasicRolandDe.shape.zip_code,
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.zip_code.title',
        },
      },
      {
        type: 'customComponent',
        shouldTrackValues: true,
        name: 'ZipCodeInput',
        props: {
          disabledIfValueExists: true,
        },
        inputs: [],
        outputs: ['zip_code'],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'legal_employment_status',
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'validateZipCode',
        options: {
          subFlow: params.subFlow,
        },
        inputs: ['zip_code'],
        outputs: ['zipValidated', 'zipValidationSubflow'],
      },
    },
  }) as const satisfies AnyStepConfiguration

export default legal_zip
